import { HttpHeaders, HttpInterceptorFn } from '@angular/common/http';

enum AuthHeaderNames {
  REQUEST_SOURCE = 'request-source',
  REQUEST_ACTION = 'request-action',
  CLIENT = 'wl-client',
}

export const myAccountInterceptor: HttpInterceptorFn = (req, next) => {
  if (
    req.url.includes('api2.myaccount') ||
    req.url.includes('api2.my-account')
  ) {
    const newSettings = {
      headers: new HttpHeaders({
        accept: 'application/json',
        'Content-Type': 'application/json',
        [AuthHeaderNames.REQUEST_SOURCE]: 'DandGUK',
        [AuthHeaderNames.REQUEST_ACTION]: 'MyAccount',
        [AuthHeaderNames.CLIENT]: 'DandGUK',
      }),
      withCredentials: true,
      observe: 'response' as const,
    };
    const httpsReq = req.clone(newSettings);
    return next(httpsReq);
  }
  return next(req);
};
